import React, { useEffect, useState } from "react";
import {
  AdvertisingDetailsType,
  BusinessDetailsType,
  BusinessHomePageSection,
  BusinessProductCategoryWithProducts,
  BussinessCatalogueProducts,
  BussinessHomeCardData,
  CustomerDetailsType,
  TextCartItemType,
  theme,
} from "../pages/BussinessHomePage";
import { add, logoWhatsapp } from "ionicons/icons";
import {
  getLocalStorageItem,
  getSeoUrl,
  searchStringSuccess,
} from "../common/commonFunctions";
import { IonButton, IonIcon, IonSpinner } from "@ionic/react";
import {
  useAppSelector,
  useCustomToast,
  useModalController,
  useRecordUserInteractions,
  useStringToast,
  userActionsTable,
} from "../app/hooks";
import {
  mobileWidthBreakpoint,
  tabWidthBreakpoint,
} from "../types/form_table_data_types";
import axios from "axios";
import {
  API_SECURE_KEY,
  IDIGIZEN_BACKEND_URL,
  getSearchResults,
  getBhpProductDetailsDB,
  userUIDKey,
  getPageType,
  whatsappMessage,
} from "../types/constants";
import { getSessionDetails } from "../common/cookies";
import deepCopy from "../common/deepcopy";
import "swiper/css/pagination";
import "swiper/css";
import BhpShowAllPromoModal from "./BhpShowAllPromoModal";
import {
  AdvanceCustomizationType,
  CartItemTypes,
  PositionType,
} from "../types/data_types";
import BhpCategoriesSelection from "./BhpCategoriesSelection";
import BhpSearchModalSection from "./BhpSearchModalSection";
import BhpTrendsSection from "./BhpTrendsSection";
// import { add } from "date-fns";
// const SelectionList = lazy(() => import("../UI/SelectionList"));

const BhpSearchModal: React.FC<{
  pageLocation: "MAIN" | "SEARCH";
  adData?: AdvertisingDetailsType[];
  adMaker?: boolean;
  logoImgData: string;
  onAddFreeTextOrder: () => void;
  hasProducts: boolean;
  prodCategories: BusinessProductCategoryWithProducts[];
  controls: { fetchMode: boolean; url?: string };
  catFilter?: string;
  onlineOnly?: boolean;
  search?: string;
  subheaderTopOffsetPx?: number;
  bussinessDetailsDB?: BusinessDetailsType;
  idAdder?: string;
  textCartItems?: TextCartItemType[];
  addItemizedFromText?: (
    name: string,
    hasEntry: boolean,
    cardData: BussinessHomeCardData
  ) => void;
  addOrderItemized: (name: string) => void;
  handleCheckoutOpen?: () => void;
  handleOpenCloseCard?: (id: any) => Promise<void>;
  vypzeePage?: boolean;
  handleChildvariant?: (name: any) => void;
  handleChildAddToCart?: (
    type: any,
    firstTime: any,
    id: any,
    variantName: any,
    price: any
  ) => void;
  cartItems?: CartItemTypes[];
  expandingImgOpen?: Function;
  expandDetails?: (
    id: string | number,
    category: string,
    mode?: "PROD" | "AD"
  ) => void;
  dismiss?: () => void;
  listModeListing?: boolean;
  buttonOverride?: {
    icon?: any;
    name?: string;
    onClick: (id: string | number) => void;
  };
  currentInterval?: any[];
  setCurrentInterval?: Function;
  enableAdSpace?: boolean;
  searchCategoryClick?: (category: string) => void;
  customerDetails?: CustomerDetailsType;
  bannerButtonClick?: (url?: string) => void;
  logoImg?: { fileName: string; rotation: number; imgCss: string };
  floors?: string[];
  initialFloor?: string;
  categoriesSel?: { open: boolean; setOpen: (inp: any) => void };
  recordUserInteractions?: boolean;
  pageSection?: "MAIN" | "SEARCH";
  searchModalMode?: boolean;
  navigate?: (
    location: { obj?: PositionType; url: string },
    shopId: string,
    shopName: string
  ) => void;
  getMarketShowGetAllData?: (
    id: string,
    idx: number,
    block: string
  ) => Promise<void>;
  getMarketBlockData?: (block: string) => Promise<void>;
  refreshingData?: boolean;
  openQuery?: () => void;
  advanceCustomization: AdvanceCustomizationType;
}> = React.memo((props) => {
  const stringToast = useStringToast();
  const screenWidth = useAppSelector((state) => state.screenWidth).width;
  const isMob =
    useAppSelector((state) => state.screenWidth).width < mobileWidthBreakpoint;
  const isTab =
    useAppSelector((state) => state.screenWidth).width < tabWidthBreakpoint;
  const [prodCategoriesLocal, setProductCategoriesLocal] = useState<
    BusinessProductCategoryWithProducts[]
  >([]);
  //   const [productsLocal, setProductsLocal] = useState<BusinessProductDetails[]>(
  //     []
  //   );
  const [swiperRef2, setSwiperRef2] = useState(null);
  const prodCategories: BusinessProductCategoryWithProducts[] = props.controls
    .fetchMode
    ? prodCategoriesLocal
    : props.prodCategories;
  const [advertisementData, setAdvertisementData] = useState<
    AdvertisingDetailsType[]
  >([]);

  //   const products: BusinessProductDetails[] = props.controls.fetchMode
  //     ? productsLocal
  //     : props.products;
  const regexMatch = (search: string, inputString: string): boolean => {
    let pattern = `%${search}%`;
    // Escape special characters in the pattern and convert % to .* (match any character zero or more times)
    const regexPattern = pattern
      .replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
      .replace(/%/g, ".*");

    // Create a regular expression object
    const regex = new RegExp(regexPattern, "i");

    // Find the matching substring
    const match = regex.exec(inputString);

    // If no match found, return null
    if (!match) {
      return false;
    } else {
      return true;
    }
  };

  // const [currentInterval, setCurrentInterval] = useState(null);

  // useEffect(() => {
  //   const startSwiper = () => {
  //     if (props.currentInterval.length) {
  //       for (const interval of props.currentInterval) {
  //         clearInterval(interval);
  //       }
  //     }
  //     if (advertisementData.length) {
  //       const timeout = 2500;

  //       let interval = setInterval(async () => {
  //         if (swiperRef2) {
  //           //console.log("Swiper ref ", swiperRef2);
  //           let nextIdx = 0;
  //           if (swiperRef2.activeIndex === advertisementData.length - 1)
  //             nextIdx = 0;
  //           else nextIdx = swiperRef2.activeIndex + 1;
  //           // console.log("Current Idx ", currentBannerIndex, " ", nextIdx);
  //           swiperRef2.slideTo(nextIdx);
  //           //  swiperRef.slideNext();
  //         } else {
  //           console.log("Swiper was null");
  //         }
  //       }, timeout);
  //       props.setCurrentInterval((prevState) => {
  //         return [...prevState, interval];
  //       });
  //     }
  //   };
  //   if (props.enableAdSpace) setTimeout(startSwiper, 1000);
  // }, [advertisementData]);

  useEffect(() => {
    setSelectedFloor(props.initialFloor ? props.initialFloor : "");
  }, [props.initialFloor]);

  const presentToast = useCustomToast();
  const [timeoutCbk, setTimeoutCbk] = useState<any>(null);
  const [filteredProdCategories, setFilteredProdCategories] = useState<
    BusinessProductCategoryWithProducts[]
  >([]);
  // const [currentSearch, setCurrentSearch] = useState<string>("XXZZ");
  const [showAllPromos, setShowAllPromos] = useState<boolean>(false);
  const [openShowAllPromos, closeShowAllPromo] = useModalController(
    "allPromoModal",
    setShowAllPromos,
    () => {
      setShowAllPromos(false);
    }
  );

  const [selectedFloor, setSelectedFloor] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [marketSearch, setMarketSearch] = useState(false);

  const promoSectionJsx = (
    <>
      <BhpShowAllPromoModal
        logoImgData={props.logoImgData}
        theme={theme}
        expandAdImage={(filename) => {
          props.expandingImgOpen({
            fileName: filename,
            index: 0,
            open: true,
          });
        }}
        allShops={prodCategories}
        bannerButtonClick={props.bannerButtonClick}
        customerDetails={props.customerDetails}
        logoImg={props.logoImg}
        open={showAllPromos}
        onDismiss={() => {
          closeShowAllPromo();
        }}
        advertisingBannerData={advertisementData}
        bussinessDetailsDB={props.bussinessDetailsDB}
        advanceCustomization={props.advanceCustomization}
      />
      <BusinessHomePageSection
        displayOff={!advertisementData.length}
        subHeaderText={
          props.search
            ? "Relevant Deals"
            : props.bussinessDetailsDB.isMarket &&
              props.bussinessDetailsDB.marketType === "MARKET"
            ? "Hot Offers & Deals"
            : "Offers & Promo"
        }
        enableSubheaderStickyScroll={false}
        subHeaderNoBg={true}
        headingLine={true}
        // bgStyle="linear-gradient(to bottom, white, #fffeac 60%,white)"
        subHeaderButtons={[
          {
            color: "dark",
            fill: "solid",
            name: "See All",
            onClick: () => {
              openShowAllPromos(true);
            },
          },
        ]}
      >
        <BhpTrendsSection
          bussinessDetailsDB={props.bussinessDetailsDB}
          openTrendsExpand={(id) => {
            props.expandDetails(id, "", "AD");
          }}
          adData={advertisementData}
          editMode={false}
          pageId={props.bussinessDetailsDB.id}
          pageSection="MAIN"
          recordUserInteraction={true}
          advanceCustomization={props.advanceCustomization}
        />
        {/* <Swiper
          slidesPerView={"auto"}
          modules={[Pagination]}
          // navigation={true}
          zoom={true}
          pagination={{
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 5,
          }}
          onSwiper={setSwiperRef2}
        >
          {advertisementData.map((el, idx) => {
            return (
              <SwiperSlide key={idx} className="bhp-slider-width">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <BhpAdBannerWrapper
                    contextIsShop={!props.bussinessDetailsDB.isMarket}
                    businessId={props.bussinessDetailsDB.id}
                    idx={idx}
                    adData={el}
                    logoImgData={props.logoImgData}
                    domainName={props.bussinessDetailsDB.domainName}
                    marketDomain={
                      !props.bussinessDetailsDB.isMarket
                        ? props.bussinessDetailsDB.marketDomain
                        : ""
                    }
                    marketName={
                      !props.bussinessDetailsDB.isMarket
                        ? props.bussinessDetailsDB.marketName
                        : props.bussinessDetailsDB.name
                    }
                    marketType={props.bussinessDetailsDB.marketType}
                    pageId={props.bussinessDetailsDB.id}
                    pageSection={"AD_ALL"}
                    recordUserInteraction={true}
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper> */}
      </BusinessHomePageSection>
    </>
  );
  const enableBackendSearch =
    ((props.bussinessDetailsDB.isMarket &&
      props.bussinessDetailsDB.marketType === "MARKET") ||
      props.bussinessDetailsDB.marketType === "MARKET_CLUSTER" ||
      props.vypzeePage) &&
    !marketSearch;
  console.log("Enable backend search ", enableBackendSearch);

  useEffect(() => {
    /*****************************************************************
     * Name : triggerBackendSearch
     * Description : Function to trigger the search
     *****************************************************************/
    const triggerBackendSearch = async () => {
      try {
        let { id, session } = getSessionDetails();
        setLoadingSearch(true);
        // const filteredCats = prodCategories.filter((el) => {
        //   return !props.catFilter || el.category === props.catFilter;
        // });
        const uid = getLocalStorageItem(userUIDKey);
        let res = await axios.post(
          `${IDIGIZEN_BACKEND_URL}/${getSearchResults}`,
          {
            id: id,
            merchantId: props.bussinessDetailsDB.id,
            isMarket: props.bussinessDetailsDB.isMarket,
            domain: props.bussinessDetailsDB.isMarket
              ? props.bussinessDetailsDB.marketDomain
              : props.bussinessDetailsDB.domainName,
            searchString: props.search,
            url: window.location.href,
            session,
            uid,
            isMarketCluster:
              props.bussinessDetailsDB.isMarket &&
              props.bussinessDetailsDB.marketType === "MARKET_CLUSTER",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: API_SECURE_KEY,
            },
            params: {
              Authorization: API_SECURE_KEY,
            },
          }
        );
        const prodCatDataL: BusinessProductCategoryWithProducts[] =
          res.data.data.result;
        setFilteredProdCategories(prodCatDataL);
        setAdvertisementData(res.data.data.advertisement);
        console.log(
          "Search results products ",
          prodCatDataL,
          "advertisement ",
          res.data.data.advertisement
        );
        setLoadingSearch(false);
      } catch (err) {
        setLoadingSearch(false);
        // console.log();
        stringToast("Error in getting search data");
      }
    }; //end of triggerBackendSearch
    if (!!timeoutCbk) clearTimeout(timeoutCbk);

    if (!!props.search) {
      console.log("BhpSearchModal called : search = ", props.search);
      // setCurrentSearch(props.search);
      if (enableBackendSearch) {
        setTimeoutCbk(setTimeout(triggerBackendSearch, 1000));
      } else {
        setFilteredProdCategories((prevState) => {
          const filteredL: BusinessProductCategoryWithProducts[] =
            deepCopy(prodCategories);
          const searchStr = props.search.trim();
          for (const cat of filteredL) {
            cat.products = cat.products.filter((el) => {
              if (regexMatch(searchStr, el.name)) return true;
              if (regexMatch(searchStr, el.shortDescription)) return true;
              if (regexMatch(searchStr, el.description)) return true;
              if (regexMatch(searchStr, cat.category)) return true;
              return false;
            });
          }
          return filteredL.filter(
            (el) =>
              !!el.products.length && el.category.toLowerCase() !== "featured"
          );
        });
      }
    } else {
      setAdvertisementData(
        props.adData
          ? props.adData.filter(
              (el) =>
                el.exportToMarket === "YES" ||
                !props.bussinessDetailsDB.isMarket
            )
          : []
      );
      setMarketSearch(false);
      let catFiltered = prodCategories;
      // .filter((el) => {
      //   return !props.catFilter || el.category === props.catFilter;
      // });
      // if (!!selectedFloor) {
      //   const filteredIdx = [];
      //   catFiltered = deepCopy(catFiltered);
      //   for (let idx = 0; idx < catFiltered.length; idx++) {
      //     const cat = catFiltered[idx];
      //     cat.products = cat.products.filter(
      //       (el) => el?.floor === selectedFloor
      //     );
      //     if (!cat.products.length) {
      //       filteredIdx.push(idx);
      //     }
      //   }
      //   catFiltered = catFiltered.filter(
      //     (_, index) => !filteredIdx.includes(index)
      //   );
      // }
      setFilteredProdCategories(catFiltered);
    }
  }, [props.search, prodCategories, selectedFloor, enableBackendSearch]);

  /*****************************************************************
   * Name : filterForDisplay
   * Description : Function to filter the products based on the
   *               search string.
   *****************************************************************/
  const filterForDisplay = (
    item: BusinessProductCategoryWithProducts
  ): BussinessCatalogueProducts[] => {
    let retVal = [];
    if (!props.search.trim()) {
      retVal.push(...item.products);
      return retVal;
    }

    //return all the products if it is category match
    if (searchStringSuccess(props.search, item.category)) {
      retVal.push(...item.products);
    }

    const filteredProd = item.products.filter((item) => {
      if (
        props.onlineOnly &&
        !(
          item.subscriptionType === "TIER-I" ||
          item.subscriptionType === "TIER-II"
        )
      )
        return false;
      for (const propName of [
        "name",
        "description",
        "productList",
        "shortDescription",
      ]) {
        if (
          item[propName] &&
          searchStringSuccess(props.search, item[propName])
        ) {
          return true;
        }
      }
      return false;
    });
    return filteredProd;
  };

  const [hasProducts, setHasProducts] = useState(true);
  const { firstname } = getSessionDetails();
  const recordAction = useRecordUserInteractions();

  useEffect(() => {
    // const EmptyArrayMessage = document.getElementById("Empty_arary_message");
    // if (!!props.search) {
    //   const renderDivElem = document.getElementsByClassName("filtered_buying");
    //   if (!renderDivElem.length) {
    //     if (EmptyArrayMessage) {
    //       EmptyArrayMessage.style.display = "block";
    //     }
    //   } else {
    //     if (EmptyArrayMessage) {
    //       EmptyArrayMessage.style.display = "none";
    //     }
    //   }
    // } else {
    //   if (EmptyArrayMessage) {
    //     EmptyArrayMessage.style.display = "none";
    //   }
    // }
    const filtered = prodCategories;
    // .filter((el) => {
    //   return !props.catFilter || el.category === props.catFilter;
    // });
    let hasProd = false;
    if (filtered && filtered.length) {
      for (const item of filtered) {
        const prods = filterForDisplay(item);
        if (prods.length) hasProd = true;
      }
    }
    setHasProducts(hasProd);
  }, [props.search, prodCategories]);

  useEffect(() => {
    console.log("Category filter ", props.catFilter);
    if (!!props.catFilter) {
      setTimeout(() => {
        handleScroll(props.catFilter);
      }, 500);
    }
  }, [prodCategories, props.catFilter]);

  const marketMode =
    (props.bussinessDetailsDB.isMarket &&
      props.bussinessDetailsDB.marketType === "MARKET") ||
    props?.controls?.fetchMode;

  const productNotFoundJsx = (
    <>
      <div
        id="Empty_arary_message"
        className="buying_page_main"
        style={{
          fontSize: "1rem",
          padding: "1rem",
          textAlign: "center",
          color: "red",
        }}
      >
        <div style={{ marginBottom: "5px" }}>
          {`${
            marketMode || props.vypzeePage
              ? "Entry not found!"
              : "Couldn't find what you are looking for?"
          }`}
        </div>
        {!marketMode && !props.vypzeePage && (
          <IonButton
            onClick={() => {
              props.onAddFreeTextOrder();
            }}
          >
            <IonIcon icon={add} slot="start" />
            Add Text Order
          </IonButton>
        )}
      </div>
    </>
  );

  const handleScroll = (valIn: string, isCentre: boolean = false) => {
    const val = `${props.idAdder}${valIn}`;
    console.log("Scroll to id ", val);
    const element = document.getElementById(val);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: isCentre ? "center" : "start",
      });
    }
    console.log(" input clicked ", element);
  };

  useEffect(() => {
    const getData = async (url: string) => {
      try {
        const data = await axios.get(
          `${IDIGIZEN_BACKEND_URL}/${getBhpProductDetailsDB}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: API_SECURE_KEY,
            },
            params: {
              schoolIdQ: 0,
              domainName: url,
              Authorization: API_SECURE_KEY,
              directoryMode: true,
            },
          }
        );

        const catProds: BusinessProductCategoryWithProducts[] =
          data.data.data.data;
        // console.log("Get response products ", data);
        // const productsL: BusinessProductDetails[] = [];
        // let advertisingDataL: AdvertisingDetailsType[] = [];
        // for (const el of productsPreProcessing) {
        //create the desc. for each variant of the product.
        // productsL.push(el);
        // if (el.catImg) {
        //   el.catImgObj = convertImgJsonToObj(el.catImg);
        // }
        // if (!el.image) {
        //   productsL[productsL.length - 1].image = [];
        // } else {
        //   productsL[productsL.length - 1].image = el.image
        //     .split("|")
        //     .filter((el) => {
        //       return el !== "undefined" && el !== "";
        //     });
        // }
        //create a flat array of advertising data
        //   if (el.advertising && el.advertising.length > 0) {
        //     const advertisingDataF = el.advertising.filter((item) => {
        //       return !item.category || !productAds.includes(item.category);
        //     });
        //     advertisingDataL.push(...advertisingDataF);
        //   }
        // }
        // setHasProductsL(!!productsL.length);
        // const catProds: BusinessProductCategoryWithProducts[] =
        //   convertProductListToCatGrouped(productsL);
        // if (promoCategoriedDataL.length) {
        //   for (const cat of promoCategoriedDataL) {
        //     catProds.unshift(cat);
        //   }
        // }
        // console.log("Prod categories ", catProds);
        setProductCategoriesLocal(catProds);
      } catch (e) {
        presentToast(e);
      }
    };
    if (props.controls.fetchMode) {
      getData(props.controls.url);
    }
  }, [props.controls.fetchMode]);

  const showingFloorSelector =
    props.bussinessDetailsDB.isMarket &&
    props.bussinessDetailsDB.marketType === "MARKET" &&
    !props.search.trim() &&
    !!props.floors?.length;

  if (loadingSearch) {
    return (
      <div
        style={{
          padding: "20px 10px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <IonSpinner />
      </div>
    );
  }
  return (
    <>
      {!!props.enableAdSpace && promoSectionJsx}
      {/* {props.bussinessDetailsDB.isMarket &&
        props.bussinessDetailsDB.marketType === "RWA" && (
          <BhpBizCard
            name={firstname}
            disableCollapseExpand={true}
            isCollapsed={true}
            paddingBottomPx={10}
            buttonOverrideContactUs={{
              exec: () => {
                props.dismiss();
                setTimeout(() => {
                  window.location.assign(bhpRwaPersonalDetailsUrl);
                }, 250);
              },
              name: "Personal Details",
            }}
            buttonOverrideSave={{
              exec: () => {
                props.dismiss();
                setTimeout(() => {
                  window.location.assign(bhpRwaBusinessDetailsUrl);
                }, 250);
              },
              name: "Create Biz Card",
            }}
          />
        )} */}
      {showingFloorSelector && (
        <div
          className="bhp-search-modal-floor-selector"
          style={{
            position: "sticky",
            zIndex: 10000000,
            top: props.subheaderTopOffsetPx
              ? `${props.subheaderTopOffsetPx}px`
              : 0,
          }}
        >
          <div
            className={`bhp-search-modal-floor-el ${
              selectedFloor ? "" : "bhp-search-modal-floor-el-sel"
            }`}
            onClick={() => {
              setSelectedFloor("");
              props.getMarketBlockData("");
            }}
          >
            All Stores
          </div>
          {props.floors
            .slice()
            .sort((a, b) => a?.trim().localeCompare(b?.trim()))
            .map((el, idx) => {
              return (
                <div
                  key={idx}
                  className={`bhp-search-modal-floor-el ${
                    selectedFloor === el ? "bhp-search-modal-floor-el-sel" : ""
                  }`}
                  onClick={() => {
                    setSelectedFloor(el);
                    props.getMarketBlockData(el);
                  }}
                >
                  {el}
                </div>
              );
            })}
        </div>
      )}
      {/* {props.hasProducts && !hasProducts && productNotFoundJsx} */}
      {props?.refreshingData && (
        <div
          style={{ padding: "15px", display: "flex", justifyContent: "center" }}
        >
          <IonSpinner color={"medium"} />
        </div>
      )}

      {!props?.refreshingData && (
        <>
          {filteredProdCategories.length === 0 &&
            hasProducts &&
            productNotFoundJsx}
          {(enableBackendSearch || marketSearch) && !!props.search.trim() && (
            <div
              style={{
                padding: "10px",
                display: "flex",
                background: "var(--ion-color-bhp-footer)",
                overflow: "scroll",
              }}
            >
              {!!props.vypzeePage && (
                <>
                  <div
                    style={{
                      color: !marketSearch ? "white" : "lightgray",
                      fontWeight: !marketSearch ? "bold" : undefined,
                      marginRight: "20px",
                      borderBottom: !marketSearch ? "3px solid red" : undefined,
                    }}
                    onClick={() => {
                      setMarketSearch((val) => !val);
                    }}
                  >
                    Stores in Market
                  </div>
                  <div
                    style={{
                      color: !!marketSearch ? "white" : "lightgray",
                      fontWeight: !!marketSearch ? "bold" : undefined,
                      borderBottom: !!marketSearch
                        ? "3px solid red"
                        : undefined,
                    }}
                    onClick={() => {
                      setMarketSearch((val) => !val);
                    }}
                  >
                    Markets
                  </div>
                </>
              )}
              {!props.vypzeePage &&
                filteredProdCategories.map((el, idx) => {
                  return (
                    <div
                      key={idx}
                      style={{
                        padding: "2px 0px",
                        // background: "var(--ion-color-light)",
                        color: "white",
                        // border: "1px solid var(--ion-color-medium)",
                        // borderRadius: "5px",
                        marginRight: "20px",
                        flexShrink: "0",
                        // borderBottom: "3px solid red",
                      }}
                      onClick={() => {
                        // console.log("Called this number");
                        // props.searchCategoryClick(el.category);
                        handleScroll(el.category);
                      }}
                    >
                      {el.category}
                    </div>
                  );
                })}
            </div>
          )}
          {!!props.search.trim() && !filteredProdCategories.length && (
            <>
              <div
                style={{
                  padding: "10px",
                  textAlign: "center",
                  fontSize: "1.3rem",
                  color: "var(--ion-color-secondary)",
                }}
              >
                <div>
                  No Results Found For <b>"{props.search}"</b>!
                </div>
                {!props.bussinessDetailsDB.isMarket && (
                  <div
                    style={{
                      padding: "10px",
                      background: "var(--ion-color-dark)",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        padding: "10px",
                        color: "var(--ion-color-light)",
                      }}
                    >
                      Didn't find what you are looking for?
                    </div>
                    <IonButton
                      expand="block"
                      color={"light"}
                      onClick={props.openQuery}
                    >
                      + Add Product Query
                    </IonButton>
                  </div>
                )}
              </div>
              {props.bussinessDetailsDB.isMarket &&
                props.bussinessDetailsDB.marketType === "MARKET" && (
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        padding: "10px 15px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        background:
                          "linear-gradient(to bottom right, rgba(var(--ion-color-medium-rgb),0.9), rgba(var(--ion-color-medium-rgb),0.65))",
                        color: "white",
                        border: "1px solid lightgray",
                        borderRadius: "10px",
                      }}
                    >
                      <div>
                        Shop Not Listed in {props.bussinessDetailsDB.name}?
                      </div>
                      <div style={{ marginTop: "10px", width: "100%" }}>
                        <IonButton
                          expand="block"
                          onClick={() => {
                            whatsappMessage(
                              `Hello Team Vypzee, I want to list my shop in ${props.bussinessDetailsDB.name}`,
                              "8448338565"
                            );
                          }}
                        >
                          <IonIcon icon={logoWhatsapp} slot="start" />
                          Contact Us & Get Listed!
                        </IonButton>
                      </div>
                    </div>
                  </div>
                )}
            </>
          )}
          {!props.prodCategories.length && !!props?.searchModalMode && (
            <div style={{ padding: "10px" }}>
              <div style={{ paddingBottom: "10px" }}>No Products to search</div>
              <IonButton
                expand="block"
                onClick={() => {
                  window.location.assign(
                    getSeoUrl(props.bussinessDetailsDB.seoUrlDetails, true)
                  );
                }}
              >
                Search in {props.bussinessDetailsDB?.marketName}
              </IonButton>
            </div>
          )}
          {filteredProdCategories.length > 0 &&
            filteredProdCategories.map((item, idx) => {
              // console.log("filteredProdCategories : item =", item);
              return (
                <BhpSearchModalSection
                  getMarketShowGetAllData={async (id: string, idx: number) => {
                    props?.getMarketShowGetAllData(id, idx, selectedFloor);
                  }}
                  key={idx}
                  sectionIdx={idx}
                  pageLocation={props.pageLocation}
                  navigate={props.navigate}
                  expandDetails={(id) => {
                    props.expandDetails(id, item.category);
                  }}
                  addOrderItemized={props.addOrderItemized}
                  bussinessDetailsDB={props.bussinessDetailsDB}
                  dismiss={props.dismiss}
                  sectionObj={item}
                  vypzeePage={props.vypzeePage}
                  adData={props.adData}
                  adMaker={props.adMaker}
                  addItemizedFromText={props.addItemizedFromText}
                  buttonOverride={props.buttonOverride}
                  cartItems={props.cartItems}
                  expandingImgOpen={props.expandingImgOpen}
                  handleCheckoutOpen={props.handleCheckoutOpen}
                  handleChildAddToCart={props.handleChildAddToCart}
                  handleChildvariant={props.handleChildvariant}
                  handleOpenCloseCard={props.handleOpenCloseCard}
                  idAdder={props.idAdder}
                  listModeListing={props.listModeListing}
                  marketMode={marketMode}
                  search={props.search}
                  showingFloorSelector={showingFloorSelector}
                  subheaderTopOffsetPx={props.subheaderTopOffsetPx}
                  textCartItems={props.textCartItems}
                  pageSection={props.pageSection}
                  recordUserInteractions={props.recordUserInteractions}
                  advanceCustomization={props.advanceCustomization}
                />
              );
            })}
          {props.categoriesSel && (
            <BhpCategoriesSelection
              bussinessDetailsDB={props.bussinessDetailsDB}
              categoryCardClick={(category) => {
                recordAction({
                  action: userActionsTable.categoryClick,
                  pageId: props.bussinessDetailsDB.id,
                  pageSection: "CATEGORY_EXPAND_SEARCH",
                  pageType: getPageType(
                    props.bussinessDetailsDB.isMarket,
                    props.bussinessDetailsDB.marketType
                  ),
                  notes: category,
                });
                handleScroll(category);
                props.categoriesSel.setOpen(false);
              }}
              dismiss={() => {
                props.categoriesSel.setOpen(false);
              }}
              open={props.categoriesSel.open}
              prodCategories={filteredProdCategories}
              advanceCustomization={props.advanceCustomization}
            />
          )}
        </>
      )}
    </>
  );
});

export default BhpSearchModal;
